import type { Lang } from "../i18n/translations";

export const STAT_KEYS = ["cities", "locations", "ac", "dc"] as const;
export type StatKey = (typeof STAT_KEYS)[number];

export type Mode = "cards" | "inline" | "hero" | "stacked";
export type Theme = "light" | "dark" | "transparent" | "auto";
export type Density = "compact" | "cozy" | "comfortable";
export type Size = "sm" | "md" | "lg";
export type Align = "left" | "center" | "right";
export type Format = "long" | "compact";
export type Brand = "minimal" | "full" | "none";
export type ShadowKind = "soft" | "none" | "elevated";
export type RadiusKind = "lg" | "md" | "none";

export interface StatsConfig {
  // Display
  mode: Mode;
  density: Density;
  size: Size;
  align: Align;
  // Selection / order
  show: StatKey[];
  /** key for hero mode */
  heroKey: StatKey;
  // Labels
  labels: Partial<Record<StatKey, string>>;
  lang: Lang | "auto";
  noLangToggle: boolean;
  // Theme
  theme: Theme;
  accent: string;
  bgOverride?: string;
  fgOverride?: string;
  border: boolean;
  radius: RadiusKind;
  shadow: ShadowKind;
  // Number
  format: Format;
  locale: string;
  // Behavior
  refreshSec: number; // 0 = no auto-refresh
  animate: boolean;
  autosize: boolean;
  // Branding
  brand: Brand;
}
